import React from "react";
import { useParams } from "react-router";

import { EditComp } from "../Edit";

export function Clone() {
    const { id } = useParams();
    return <EditComp id={id} title="Clone Product" isClone />;
}
